var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-button',{class:`md-info md-sm w-auto help ${_vm.active}`,on:{"click":_vm.click}},[_c('img',{attrs:{"src":require(`@/assets/icons/${_vm.img}.png`),"alt":"ireal icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }